import { Box, InputBase, InputBaseProps, styled, alpha } from '@material-ui/core'
import { useRef } from 'react'

const TextBox = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  borderRadius: "8px",
  backgroundColor: "#fff",
  '&:hover': {
    backgroundColor: alpha('#fff', 0.85),
  },
  border: "3px solid #373737",
  marginLeft: 0,
  width: '100%',
  height: '36px',
  boxShadow: '0 0.125rem 0.25rem rgba(0, 0, 0, 0.1)',
  flexShrink: 99,
}))

const TextBoxIconWrapper = styled(Box)(() => ({
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: "#145DAD",
  cursor: 'text',
}))

const TextBoxStyledInputBase = styled(InputBase)(() => ({
  '& .MuiInputBase-input': {
    fontSize: '16px',
    fontFamily: 'ABeeZee'
  },
  width: '100%',
}))

interface I4kTextFieldProps extends InputBaseProps {
  leftIcon?: any
  rightIcon?: any
}

const I4kTextField: React.FC<I4kTextFieldProps> = ({
  leftIcon,
  rightIcon,
  ...inputProps
}) => {
  const inputRef = useRef<HTMLInputElement>(null)

  const handleFocus = () => {
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }

  return (
    <Box>
      <TextBox>
        {leftIcon && (
          <TextBoxIconWrapper onClick={handleFocus}>
            {leftIcon}
          </TextBoxIconWrapper>
        )}
        <TextBoxStyledInputBase
          inputRef={inputRef}
          style={{
            minWidth: '40px',
          }}
          {...inputProps}
        />
        {rightIcon && (
          <TextBoxIconWrapper onClick={handleFocus} style={{ marginLeft: "8px" }}>
            {rightIcon}
          </TextBoxIconWrapper>
        )}
      </TextBox>
    </Box>
  )
}

export default I4kTextField
